export const ASSIGN_TOOL_ID = 'assign-patients-tool';
